export default "__VITE_ASSET__cda469fd__"